import React from "react";
import { Certificate } from "../types";

type Props = {
  certificates: Certificate[];
};

export default function Certificates({ certificates }: Props) {
  if (!certificates || certificates.length === 0) return null;

  return (
    <section>
      <h2 className="section-title">Certifications</h2>
      <div className="section-divider mb-6" />

      <div className="flex flex-wrap gap-4 justify-center">
        {certificates.map((cert, i) => {
          const isGold = cert.state === "Obtenue";
          return (
            <div
              key={i}
              className={`w-56 rounded-xl p-4 text-center border-2 transition-shadow
                ${
                  isGold
                    ? "border-freelance-available/40 bg-freelance-available/5"
                    : "border-accent/40 bg-accent/5"
                }
                hover:shadow-md`}
            >
              <img
                src={cert.image}
                alt={cert.name}
                className="w-32 h-auto mx-auto mb-3"
              />
              <p className="font-semibold text-sm text-text-light dark:text-text-dark">
                {cert.name}
              </p>
              <div className="section-divider my-2 w-1/2 mx-auto" />
              <p className="text-xs text-text-light-muted dark:text-text-dark-muted">
                {cert.month}{" "}
                <span className="font-semibold">{cert.year}</span>
              </p>
              <span
                className={`inline-block mt-2 px-3 py-0.5 rounded-full text-xs font-medium
                  ${
                    isGold
                      ? "bg-freelance-available/10 text-freelance-available"
                      : "bg-accent/10 text-accent"
                  }`}
              >
                {cert.state}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
